import React from 'react';
import { browserHistory } from 'react-router';

import { googleAnalytics } from '@evdy/web-core/dist/lib/utils';

import CardOutline from '../CardOutline';
import InlineInput from '../InlineInput';

import styles from './MessageCTA.module.scss';

import infoIcon from '../../public/images/icons/blue-info-circle.svg';

const {
  'message-cta': messageCTAClass,
  'blog-link': blogLinkClass,
  divider,
  input,
  'user-img-container': userImgContainerClass,
  'user-img-desktop': userImgDesktopClass,
  'user-img-mobile': userImgMobileClass,
  'cta-content': ctaContentClass,
  'input-container': inputContainerClass,
  'static-ad': staticAdClass
} = styles;

const MessageCTA = ({ baseRoute, userName, userImage, decedentDetails }) => {
  const handleClick = () => {
    browserHistory.push({ pathname: `${baseRoute}/condolence/create` });
  };
  const { name: decedentName } = decedentDetails || {};

  const inputPlaceholder = 'Write your message here...';

  return (
    <div className={messageCTAClass}>
      <CardOutline>
        <h1>Share your memories, condolences & support</h1>
        <div className={userImgContainerClass}>
          {userImage && (
            <div
              className={userImgDesktopClass}
              style={{ backgroundImage: `url('${userImage}')` }}
            />
          )}
          <div className={ctaContentClass}>
            <div className={inputContainerClass} onClick={handleClick}>
              {userImage && (
                <div
                  className={userImgMobileClass}
                  style={{ backgroundImage: `url('${userImage}')` }}
                />
              )}
              <InlineInput customClass={input} placeholder={inputPlaceholder} />
            </div>
            <div className={divider} />
            <a
              className={blogLinkClass}
              href="https://everdays.com/blog/how-to-write-a-meaningful-condolence-letter/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <button>
                <img src={infoIcon} />
                <span>Suggested Read: Easy templates to start your message</span>
              </button>
            </a>
          </div>
        </div>
      </CardOutline>
      <CardOutline>
        <a
          href="https://everdays.com/blog/is-it-ok-to-say-i-am-sorry-for-your-loss/"
          className={staticAdClass}
          target="_blank"
          rel="noreferrer noopener"
          onClick={() => {
            googleAnalytics('blog_graphic_ad')();
          }}
        >
          Read Article
        </a>
      </CardOutline>
    </div>
  );
};

export default MessageCTA;
